import { map } from 'rxjs/operators';
import { Endpoint } from '../endpoint';
import { SiteCacheResponse } from '@business/entities/settings';
import { R } from '@core/utils/r';

export function get<T>(storeKey: string, value?: T) {
  return Endpoint.get<SiteCacheResponse<T>>(`@gc/settings/site-cache/${storeKey}`, { params: R.objectCompact({ default: value }) }).pipe(
    map(res => res.value),
  );
}

export function put<T>(storeKey: string, value: T) {
  return Endpoint.post<void>(`@gc/settings/site-cache`, { data: { storeKey, value } });
}

export function forget(storeKey: string) {
  return Endpoint.delete<void>(`@gc/settings/site-cache/${storeKey}`);
}
